import TableHeader, {
	ITableHeader,
	IHeaderColumn,
	THeaderColumnLabel
} from './TableHeader';

export type { ITableHeader, IHeaderColumn, THeaderColumnLabel };
export default TableHeader;
